import classNames from 'classnames';
import Button from '../../../Button';
import Image from '../../../Image/Image';

export default function Item({ item, showPhoto }) {
  const wrapperClasses = classNames({
    'flex items-center -mx-2': showPhoto,
    a: !showPhoto && !!item.href,
  });
  const contentClasses = classNames({
    a: !!item.href,
  });

  const Wrapper = () => {
    if (showPhoto) {
      return (
        <section className="px-2">
          <span className={contentClasses}>{item.name}</span>

          {item.role && <section>Role: {item.role}</section>}
        </section>
      );
    }

    return (
      <>
        {item.name}
        {item.role ? ` ${item.role}` : ''}
        {item.year ? ` (${item.year})` : ''}
      </>
    );
  };
  return (
    <>
      <Button
        as={item.href ? 'a' : 'span'}
        className={wrapperClasses}
        variant="clear"
        href={item.href}
      >
        {showPhoto && (
          <section className="px-2">
            <section className="relative w-[50px] h-[50px] rounded-full border-2 overflow-hidden">
              <Image src={item.photo} className="object-cover h-full w-full" />
            </section>
          </section>
        )}
        <Wrapper />
      </Button>
    </>
  );
}
